export default function(
    store,route,router,
    formColumnConfig,//表单label相关配置
    formOption,//表单配置
    clickBtnSelectObj,//自定义点击类型按钮配置
    fromHndleEventObj,
    _axios,
    showToast,
    showConfirm
){
    formOption.labelWidth = 180
    formOption.newApiOption.api = `/sys/giftPacks/addCommodity`

    getAreaList()
    async function getAreaList(){
        const res = await _axios('post','/sys/productRegion/list',{},true)
        formColumnConfig[1].option = res
        formColumnConfig[1].lkey = 'regionName'
        formColumnConfig[1].vkey = 'id'
    }
}
